// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300214/js/" + chunkId + "." + {"44":"5a557ff4","225":"946c30dc","481":"16bfe840","486":"e763026c","770":"785e82e9"}[chunkId] + ".0.7343272979604892.chunk.js";
};